import {Button} from '@trussworks/react-uswds';
import {useId} from 'react';
import {PlacesType, Tooltip} from 'react-tooltip';
import {small_tooltip_style} from '../../../lib/utils';

interface Props {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  tooltip_text: string;
  children: React.ReactNode;
  className?: string;
  is_outline?: boolean;
  is_disabled?: boolean;
  is_small_tooltip?: boolean;
  tooltip_place?: PlacesType;
  id?: string;
}

export default function ButtonWithTooltip({
  onClick,
  tooltip_text,
  children,
  className,
  is_outline,
  is_disabled,
  is_small_tooltip,
  tooltip_place,
  id,
}: Props) {
  const generated_id = useId();
  id ||= generated_id;

  return (
    <>
      <Button
        id={id}
        outline={is_outline}
        type="button"
        onClick={onClick}
        disabled={is_disabled}
        className={className}
        aria-label={tooltip_text}
      >
        {children}
      </Button>
      <Tooltip
        anchorSelect={`#${CSS.escape(id)}`}
        place={tooltip_place || 'bottom'}
        style={is_small_tooltip ? small_tooltip_style : undefined}
      >
        {tooltip_text}
      </Tooltip>
    </>
  );
}
